import { SelectList, ListItem, Button, Icons } from 'construct-ui'
import codeMasterModel from '../../models/common/code-master.model'

/**
 * @deprecated
 * 
 * Instead, please use
 * ```
 * src\app\components\multi-select\multi-select.component.js
 * ```
 */
export default function selectListComponent() {
  let _attrs;
  let selectedList = [];
  let items = [];
  let _countryCode = '';

  function renderItem(item) {
    return m(ListItem, {
      label: item.name,
      selected: (selectedList.indexOf(item.code) > -1),
    })
  }

  function itemPredicate(query, item) {
    return item.name.toLowerCase().includes(query.toLowerCase());
  }

  function handleSelect(item) {
    if (item.code == "") {
      selectedList.splice(0, selectedList.length);
    } else if (selectedList.indexOf(item.code) > -1) {
      selectedList.splice(selectedList.indexOf(item.code), 1)
    } else selectedList.push(item.code);

    _attrs.handleSelect(selectedList);
  }

  function renderLabel() {
    let selectedLabels = [];
    if (selectedList.length < 1) {
      return 'Choose...';
    } else if (selectedList.length < 2) {
      items.map(item => {
        if (selectedList.indexOf(item.code) > -1) {
          selectedLabels.push(item.name);
        }
      });
      return selectedLabels.join(", ");
    } else {
      return selectedList.length + " selected";
    }
  }

  let getCodeMasterByCategory = () => {
    items = [];
    codeMasterModel.getByCategory(
      (result) => {
        for (var i = 0; i < result.length; i++) {
          items.push(result[i]);
        }
      },
      (error) => {
        items = [];
      },
      { category: _attrs.category, countryCode: _countryCode }
    );
  }

  return {
    oninit: ({ attrs }) => {
      _attrs = attrs;
      _countryCode = _attrs.countryCode;
      getCodeMasterByCategory();
      selectedList = _attrs.selectedList;
    },
    onupdate: ({ attrs }) => {
      _attrs = attrs;
      if (_attrs.selectedList?.length > 0 && selectedList.length <= 0) selectedList = _attrs.selectedList;
    },
    view: ({ attrs }) => {
      _attrs = attrs;
      if (_countryCode != _attrs.countryCode) {
        _countryCode = _attrs.countryCode;
      }
      return m(".col",
        m("label.form-label",
          _attrs.label,
          _attrs.mandatory ? m('span', { "style": { "color": "red" } }, '*') : ''),
        m(SelectList, {
          closeOnSelect: false,
          items: items,
          itemRender: renderItem,
          itemPredicate: itemPredicate,
          onSelect: handleSelect,
          popoverAttrs: {
            hasArrow: false
          },
          trigger: m(Button, {
            align: 'left',
            compact: true,
            class: '',
            fluid: true,
            iconRight: Icons.CHEVRON_DOWN,
            outlined: true,
            label: renderLabel(),
          })
        }),
        _attrs.validate && !_attrs.isvalid &&
        m(
          'div', { "class": "invalid-feedback fs-6", style: 'display:block;' },
          m('small', _attrs.errorMessage)
        )
      );
    }
  };
}
